var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#47548c"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.965.834a.8.8 0 1 0-1.13 1.132l11.2 11.2a.8.8 0 0 0 1.13-1.132l-1.178-1.178A8.012 8.012 0 0 0 15.634 7 8.003 8.003 0 0 0 4.39 2.26zm3.41 3.41 1.21 1.21a1.602 1.602 0 0 1 1.96 1.96l1.212 1.212a3.2 3.2 0 0 0-4.383-4.383z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.963 12.357 7.8 10.194A3.2 3.2 0 0 1 4.806 7.2L1.868 4.262A7.984 7.984 0 0 0 .366 7a8.004 8.004 0 0 0 9.597 5.357z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.8c1a154e22b094c4152eeeaa4a86aa47.svg";
export { ForwardRef as ReactComponent };